import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getHashFragment } from '../../utils/uriUtils';
import classnames from 'classnames';
import styles from './SbSharedRedirectedItem.scss';

export const SbSharedRedirectedItem = () => {
    const [itemExists, setItemExists] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const { href } = window.location;
        const fragment = getHashFragment(href);
        setItemExists(fragment.includes('#itemId'));
    });

    if (itemExists) {
        const textWrapperClass = classnames(styles.textWrapper, {
            [styles.withoutImage]: true,
        });

        return (
            <div className={styles.wrapper} data-tn="redirected-item">
                <div className={textWrapperClass}>
                    <div className={styles.title}>
                        <FormattedMessage
                            id="SbSharedRedirectedItem.notAvailableItemWithoutPhoto"
                            defaultMessage="Sorry, this item is not currently available."
                        />
                    </div>
                    <div className={styles.text}>
                        <FormattedMessage
                            id="SbSharedRedirectedItem.browseBelow"
                            defaultMessage="Browse available items below."
                        />
                    </div>
                </div>
            </div>
        );
    }

    return null;
};
